export function getAttachmentsTokens() {
  var files = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var uploadedFiles = files.filter(function (f) {
    return f.status === 'succeed';
  });
  return uploadedFiles.map(function (f) {
    return f.uploadedFile;
  });
}